import * as yup from 'yup';

import getPeriodSchema from './ControlledTimePeriodSchema';

const periodSchema = getPeriodSchema();

const getSchema = () => {
  return yup.array().of(periodSchema).required();
};

export default getSchema;
